import { AxiosInstance } from "axios"
import { GenericResponse } from "."
import { UserModel } from "./user.api"

export interface ValueAddedServiceModel {
    id: number
    service: string
    service_value: number
    service_type: string
    category: string
    warehouse_country_code: string
    updated_by: UserModel
    created_by: UserModel
    updated_at: string
}

export interface Item {
    parcel_item_id: number
    quantity: number
}

export interface Assignments {
    fulfillment_suite_id: number
    items: Item[]
}

export interface AssignToLocationRequest {
    fulfillment_request_id: number
    assignments: Assignments[]
}

export interface CreateValueAddedServiceRequest {
    service_value?: number
    service_type?: string
    description?: string
    service?: string
    warehouse_id?: number
    is_external?: number | boolean
    min_value?: number
    category?: string
}

const FulfillmentApi = (apiInstance: AxiosInstance) => {
    const listFulfillmentRequests = async ({ warehouse }: { warehouse: string }): Promise<GenericResponse> => {
        const res: Promise<GenericResponse> = apiInstance.get(`/fulfillment/requests?warehouse_id=${warehouse}`)
        return res
    }

    const listFulfilledParcels = async ({ warehouse }: { warehouse: string }): Promise<GenericResponse> => {
        const res: Promise<GenericResponse> = apiInstance.get(
            `/fulfillment/create-parcel-list?warehouse_id=${warehouse}`
        )
        return res
    }

    const assignToLocation = async (
        assignToLocationRequest: AssignToLocationRequest
    ): Promise<GenericResponse> => {
        const res: Promise<GenericResponse> = apiInstance.post(
            `/fulfillment/assign-suites`,
            assignToLocationRequest
        )
        return res
    }

    const createParcel = async ({ parcelId }: { parcelId: number }): Promise<GenericResponse> => {
        const res: Promise<GenericResponse> = apiInstance.post(`/fulfillment/create-parcel`, {
            parcel_id: parcelId
        })
        return res
    }

    const listFulfillmentSuites = async ({ warehouse }: { warehouse: string }): Promise<GenericResponse> => {
        const res: Promise<GenericResponse> = apiInstance.get(`/fulfillment/suites?warehouse_id=${warehouse}`)
        return res
    }

    return {
        listFulfillmentRequests,
        listFulfilledParcels,
        assignToLocation,
        createParcel,
        listFulfillmentSuites
    }
}

export default FulfillmentApi
